import { render } from "./Feedback.vue?vue&type=template&id=1386257e&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "@/assets/css/feedback.sass?vue&type=style&index=0&id=1386257e&lang=sass&scoped=true"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=1386257e&lang=sass&scoped=true"
import "./Feedback.vue?vue&type=style&index=2&id=1386257e&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1386257e"]])

export default __exports__